import clsx from 'clsx';
import { useState } from 'react';
import { OptionIcon, TextArea } from '@recargas-dominicanas/core/components';
import { style } from './edit-field.module.css';

interface Props {
  title: string;
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
}

export function EditField(props: Props) {

  const { 
    title, 
    value,
    placeholder,
    onChange 
  } = props;

  const [enabled, setEnabled] = useState(false);

  return (
    <div className={style.container}>
      <div className={style.header}>
        <span className={style.title}>{title}</span>
        <OptionIcon
          className={style.icon} 
          icon='edit'
          onClick={() => setEnabled(enabled => !enabled)}/>
      </div>
      {!enabled &&
        <span 
          className={clsx(style.value, !value && style.placeholder)}
          onClick={() => setEnabled(enabled => !enabled)}>
          {value || placeholder}
        </span>
      }
      {enabled &&
        <TextArea
          style={style.textArea} 
          autofocus={true}
          value={value}
          onChange={onChange}/>
      }
    </div>
  );
}
